import { benefits } from "../data/landingData";
import Icon from "./Icons";

export default function BenefitsSection() {
  return (
    <section id="benefits" className="section benefits">
      <h2 className="section-title">Ce que ça change concrètement</h2>
      <div className="benefits-grid">
        {benefits.map((b, i) => (
          <div key={i} className="benefit-card">
            <div className="benefit-icon-wrap">
              <Icon name={b.icon} />
            </div>
            <h3 className="benefit-title">{b.title}</h3>
            <p className="benefit-desc">{b.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
